import { render, staticRenderFns } from "./DoneUploadPicture.vue?vue&type=template&id=20461de0&"
import script from "./DoneUploadPicture.vue?vue&type=script&lang=js&"
export * from "./DoneUploadPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports